import styled from "@emotion/styled";
import { Card } from "./card.type";
import { HeadingWithStep } from "../heading-with-step";
import { breakpoints } from "../../../styles/breakpoints";

const StyledFeature = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: var(--x-large) auto;
  gap: var(--large);

  @media (max-width: ${breakpoints.lg}) {
    gap: var(--medium);
  }

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    gap: var(--xx-small);
    max-width: 500px;
  }

  & + & {
    margin-top: 0;
  }

  .graphic {
    flex: 0 0 550px;

    @media (max-width: ${breakpoints.lg}) {
      flex: 0 0 450px;
    }

    @media (max-width: ${breakpoints.md}) {
      flex: none;
    }
  }

  .graphic:not(.no-bg) {
    background-color: var(--white);
    padding: var(--xx-small);
  }

  .h3 {
    margin-bottom: var(--mini);
  }

  &.inverted {
    flex-direction: row-reverse;

    @media (max-width: ${breakpoints.md}) {
      flex-direction: column;
    }

    .graphic {
      background-color: var(--divider-light);
    }
  }
`;

export const Feature = ({
  title,
  text,
  inverted,
  step,
  children,
  noBg,
}: Card) => (
  <StyledFeature className={`${inverted ? "inverted" : null}`}>
    <div className={`graphic ${noBg ? "no-bg" : null}`}>{children}</div>
    <div>
      {step ? (
        <HeadingWithStep
          type="h3"
          step={{ src: step.src, alt: `${step.number}` }}
        >
          {title}
        </HeadingWithStep>
      ) : (
        <h3 className="h3">{title}</h3>
      )}
      <p>{text}</p>
    </div>
  </StyledFeature>
);
